"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.StyledButton = exports.Right = exports.Left = exports.ButtonInner = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
var _Button = require("../Button");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//components

var stylesConfig = {
  desktop: {
    btnHeight: '56px !important',
    iconSize: 24,
    leftLaneWidth: 56
  },
  mobile: {
    btnHeight: '56px !important',
    iconSize: 16,
    leftLaneWidth: 48
  }
};
var StyledIcon = exports.StyledIcon = _styledComponents["default"].div.attrs(function (p) {
  return {
    size: stylesConfig[p.device].iconSize
  };
}).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-1owrpjt-0"
})([""]);
var ButtonInner = exports.ButtonInner = _styledComponents["default"].div.withConfig({
  displayName: "styles__ButtonInner",
  componentId: "sc-1owrpjt-1"
})(["display:flex;height:56px;"]);
var Right = exports.Right = _styledComponents["default"].div.withConfig({
  displayName: "styles__Right",
  componentId: "sc-1owrpjt-2"
})(["flex:1;display:flex;justify-content:center;align-items:center;position:relative;left:", ";font-weight:400;letter-spacing:0;@media (max-width:373px){left:0px;}"], function (p) {
  return "calc(-1 * ".concat(stylesConfig[p.device].leftLaneWidth, "px / 2)");
});
var Left = exports.Left = _styledComponents["default"].div.withConfig({
  displayName: "styles__Left",
  componentId: "sc-1owrpjt-3"
})(["display:flex;justify-content:center;align-items:center;width:", "px;"], function (p) {
  return stylesConfig[p.device].leftLaneWidth;
});
var StyledButton = exports.StyledButton = (0, _styledComponents["default"])(_Button.Button).attrs({
  design: 'solid-cool'
}).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1owrpjt-4"
})(["height:", ";"], function (p) {
  return stylesConfig[p.device].btnHeight;
});
//# sourceMappingURL=styles.js.map